import React from 'react';
import {
  Container, Image
} from 'react-bootstrap';
import { Tron } from './Tron';

export const Windows = () => {
  
  let homeTron = {
    title: 'Workspace ONE Windows Excel Add-In (Beta)',
    description: 'This is the installation documentation page for the Workspace ONE Windows Excel Add-In.',
    body: <>
      <p>This covers using this website to run the Add-In.</p>
      <p><b>However,</b> this is mostly for evaluation purposes since, for security and privacy reasons,
        there is no caching layer implemented at this time so your speed will be much higher
        with a <a href='./APIBackendWindows'>Caching API implemented</a></p>
      <p>This is easier than you think.</p>
    </>
  };
  
  
  return (
    
    <Container>
      <Tron tronProps={homeTron}/>
      <Container>
        <h4 id="copy-and-edit-manifest.xml">Copy and edit Manifest.xml</h4>
        <p>The first thing you need to do is go to the <a
          href="https://github.com/vmware-samples/euc-samples">VMware Samples GitHub</a> and download the euc-samples
          repository. Once downloaded, unzip it, and open the euc-samples-master folder, then Windows-Samples,
          Tools &amp; Utilities, and finally Excel Add-In.</p>
        <p>Copy the manifest.xml to a temporary folder on your computer</p>
        <h5>Edit the manifest.xml</h5>
        <Image alt="Edit Manifest" width='800' src='../images/WSONEEditManifest.png' fluid/>
        <ul>
          <li>Right click on the manifest.xml and click edit</li>
          <li>Click Open the Edit menu and click Replace</li>
          <li>In "Find What" put /localhost/</li>
          <li>In "Replace With" put /wsonereporting.azurewebsites.net/</li>
          <li>Click "Replace All"</li>
          <li>Save your manifest.xml</li>
        </ul>
        
        <h4>Use the manifest.xml to setup the Add-In</h4>
        <ul>
          <li>
            <p>See the following web page from Microsoft which shows step by step how to install on Excel for
              Windows</p>
            <p>
              <a
                href="https://docs.microsoft.com/en-us/office/dev/add-ins/testing/create-a-network-shared-folder-catalog-for-task-pane-and-content-add-ins">Sideload
                Office Add-ins for testing</a>
            </p>
          </li>
          <li>
            <p>After this you need to add the following registry key:</p>
            <p>[HKEY_LOCAL_MACHINE\SOFTWARE\Microsoft\Office\16.0\Wef]</p>
            <p>Then add the following dword value in the above key.</p>
            <p>"AlertInterval"=dword:00000000</p>
            <p>You need to do this when sideloading an app to tell Excel not to timeout on long queries.</p>
          </li>
        </ul>
      
      </Container>
    </Container>
  );
};

